import style from './Etc.module.css';
import Buttons from '../Buttons/Buttons';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { ADMIN_URL } from '../../utils/config';

export default function Etc({ etc, etcSmeta, setEtcSmeta, changePage }) {
    const countChange = (etcData, count) => {
        setEtcSmeta(prevSmeta => {
            const newCount = (prevSmeta[etcData.ID] || 0) + count;
            const isPackage = etcData.Name.includes('Пакет');
            
            if (isPackage) {
                // Для пакетов разрешаем только 0 или 1
                if (newCount <= 0) {
                    const updatedSmeta = { ...prevSmeta };
                    delete updatedSmeta[etcData.ID];
                    return updatedSmeta;
                }
                
                // При добавлении пакета удаляем все другие пакеты
                if (count > 0) {
                    const updatedSmeta = { ...prevSmeta };
                    
                    // Удаляем все существующие пакеты
                    Object.keys(updatedSmeta).forEach(id => {
                        const existingEtcData = etc.find(item => item.ID.toString() === id);
                        if (existingEtcData && existingEtcData.Name.includes('Пакет')) {
                            delete updatedSmeta[id];
                        }
                    });
                    
                    // Добавляем новый пакет
                    return {
                        ...updatedSmeta,
                        [etcData.ID]: 1
                    };
                }
                
                return {
                    ...prevSmeta,
                    [etcData.ID]: Math.min(newCount, 1)
                };
            }
            
            // Стандартная логика для остальных элементов
            if (newCount <= 0) {
                const updatedSmeta = { ...prevSmeta };
                delete updatedSmeta[etcData.ID];
                return updatedSmeta;
            }
            
            // Для элементов с OnlyOne = 1 ограничиваем максимальное количество 1
            if (etcData.OnlyOne === 1) {
                return {
                    ...prevSmeta,
                    [etcData.ID]: Math.min(newCount, 1)
                };
            }
            
            return {
                ...prevSmeta,
                [etcData.ID]: newCount
            };
        });
    };

    const canAddItem = (etcData) => {
        const isPackage = etcData.Name.includes('Пакет');
        const currentCount = etcSmeta[etcData.ID] || 0;
        
        if (isPackage) {
            // Для пакетов можно добавить, если текущее количество 0
            return currentCount === 0;
        }
        
        // Стандартная логика для остальных элементов
        if (etcData.OnlyOne === 1) {
            return currentCount === 0;
        }
        
        return true;
    };

    // Функция для проверки, есть ли уже какой-то пакет в etcSmeta
    const hasAnyPackage = () => {
        return Object.keys(etcSmeta).some(id => {
            const etcData = etc.find(item => item.ID.toString() === id);
            return etcData && etcData.Name.includes('Пакет');
        });
    };

    return (
        <>
            <div className={style.container}>
                {etc.map((etcData) => (
                    <div key={`etc-${etcData.ID}`} className={style.block}>
                        <img src={`${ADMIN_URL}/assets/img/etc/${etcData.Photo}`} alt={etcData.Name} className={style.block_img} />
                        <div className={style.block_text}>
                            <div className={style.block_text_title}>{etcData.Name}</div>
                            <div className={style.block_text_subtitle}>{etcData.Subtitle}</div>
                            <div className={style.block_text_about}>{etcData.About}</div>
                            <div className={style.block_price}>
                                {etcSmeta[etcData.ID] ? (
                                    <div className={style.block_count_container}>
                                        {etcData.OnlyOne === 0 && !etcData.Name.includes('Пакет') ? (
                                            // Стандартные элементы с множественным выбором
                                            <>
                                                <button className={style.button_count} onClick={() => countChange(etcData, -1)}>-</button>
                                                <input
                                                    type="number"
                                                    className={style.input_count}
                                                    value={etcSmeta[etcData.ID]}
                                                    readOnly
                                                />
                                                <button className={style.button_count} onClick={() => countChange(etcData, 1)}>+</button>
                                            </>
                                        ) : (
                                            // Элементы с OnlyOne = 1 или пакеты - показываем кнопку "Удалить"
                                            <Button
                                                className={style.block_price_button}
                                                variant="outlined"
                                                size="small"
                                                onClick={() => countChange(etcData, -1)}
                                            >
                                                Удалить
                                            </Button>
                                        )}
                                    </div>
                                ) : (
                                    // Кнопка "Добавить"
                                    <Button
                                        className={style.block_price_button}
                                        variant="contained"
                                        color="primaryDark"
                                        size="small"
                                        onClick={() => countChange(etcData, 1)}
                                        disabled={!canAddItem(etcData)}
                                    >
                                        Добавить
                                    </Button>
                                )}
                                <div className={style.block_price_text}>{etcData.Price * (etcSmeta[etcData.ID] || 1)}₽</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <Buttons button1={{ text: "Далее", onClick: () => changePage(6) }} button2={{ text: "Назад", onClick: () => changePage(4) }} />
        </>
    )
}